import { render } from "./AssignedEmailList.vue?vue&type=template&id=8b1e9d9a&scoped=true"
import script from "./AssignedEmailList.vue?vue&type=script&lang=js"
export * from "./AssignedEmailList.vue?vue&type=script&lang=js"

import "./AssignedEmailList.vue?vue&type=style&index=0&id=8b1e9d9a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.22_vue@3.5.22_typescript@4.1.6__webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b1e9d9a"]])

export default __exports__